export const shuffleAnswers = (question) => {
  const unshuffledAnswers = [
    question.correct_answer,
    ...question.incorrect_answers,
  ];

  return unshuffledAnswers
    .map((unshuffledAnswer) => ({
      sort: Math.random(),
      value: unshuffledAnswer,
    }))
    .sort((a, b) => a.sort - b.sort)
    .map((a) => a.value);
};
